.QRCodeParent {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  background: #00000069;
  border: 1.12px solid;
  backdrop-filter: blur(4px);
  position: fixed;
  bottom: 24px;
  left: 50%;
  border: 1px solid transparent;
  border-radius: 8px;
  border-image-source: linear-gradient(
    135deg,
    rgba(108, 108, 108, 1) 15%,
    rgba(108, 108, 108, 0) 50%,
    rgba(108, 108, 108, 1) 85%
  );
  border-image-slice: 1;
  background-clip: padding-box;
  transform: translate(-50%, 0);
  padding: 16px;
  z-index: 10000;
}

.QRCodeContent {
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: var(--text-color-1);
  width: 120px;
  text-align: left;
}

.QRCodeHeading {
  font-family: Denton Test, sans-serif;
  font-weight: 300;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 1px;
  margin: 0;
}

.QRCodeDesc {
  margin: 0;
  font-weight: 300;
  font-size: 12px;
  line-height: 20.34px;
  vertical-align: middle;
}

.qrCode {
  height: 80px;
  width: 80px;
}
